// Business constants

/** Kit Keeper office phone number (display format) */
export const COMPANY_PHONE = '020 3868 6815';

/** Kit Keeper office phone number (tel: URI format, E.164) */
export const COMPANY_PHONE_TEL = '+442038686815';

// Warehouse workflow flags

/** When true, Receive auto-chains through WKKU to WKKS in a single scan.
 *  Set to false to restore the separate Receive + Store two-step flow. */
export const AUTO_STORE_ON_RECEIVE = true;

/** When true, warehouse location modal is shown during the store step.
 *  Disabled until location barcode scanning is ready. */
export const SHOW_WAREHOUSE_LOCATION_MODAL = false;
